import { useEffect } from "react";

const SITE = "مدينتي لتقنيات المعلومات والحلول الذكية";
const BASE = "https://www.madenati.dlr.iq";
const LOGO = `${BASE}/logo192.png`;

// Aggregate site-wide JSON-LD (LocalBusiness) — always present on any page.
const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${BASE}#business`,
  name: "Madinaty for Information Technology and Smart Solutions",
  alternateName: "مدينتي لتقنيات المعلومات والحلول الذكية",
  url: BASE,
  logo: LOGO,
  image: LOGO,
  telephone: "+964-782-669-9000",
  email: "madenati@dlr.iq",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Al-Aradat Al-Hindiya, Karrada — near Development Bank",
    addressLocality: "Baghdad",
    addressRegion: "Baghdad",
    addressCountry: "IQ",
  },
  areaServed: { "@type": "Country", name: "Iraq" },
  openingHoursSpecification: [{
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
    opens: "08:00",
    closes: "17:00",
  }],
  sameAs: [
    "https://facebook.com/madenati.tech",
    "https://instagram.com/madenati.tech",
    "https://linkedin.com/company/madenati-tech",
    "https://tiktok.com/@madenati.tech",
  ],
  description:
    "Iraqi company specialized in ERP, hotel management, SCADA, security systems, AI solutions, mobile apps and web design.",
  makesOffer: [
    "Hotel Management Systems", "ERP Business Systems",
    "SCADA Systems", "Security Cameras & Systems", "Website Design",
    "Mobile Apps", "AI Solutions", "Hosting & Servers",
  ].map((n) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: n } })),
};

function injectJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

function removeJsonLd(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export default function Seo({ title, description, jsonLd = null, jsonLdId = "seo-jsonld-page" }) {
  useEffect(() => {
    document.title = title ? `${title} | مدينتي` : SITE;
    const setMeta = (sel, val) => {
      const m = document.querySelector(sel);
      if (m && val) m.setAttribute("content", val);
    };
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', `${title} | مدينتي`);
      setMeta('meta[name="twitter:title"]', `${title} | مدينتي`);
    }
    // Always ensure site-wide LocalBusiness LD is present
    injectJsonLd("seo-jsonld-business", LOCAL_BUSINESS_LD);
    if (jsonLd) injectJsonLd(jsonLdId, jsonLd);
    return () => {
      document.title = SITE;
      if (jsonLd) removeJsonLd(jsonLdId);
    };
  }, [title, description, jsonLd, jsonLdId]);
  return null;
}

// Helper factories consumers can use to build page-scoped JSON-LD.
export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (items || []).map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
});

export const serviceJsonLd = ({ name, description, image, url }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  image,
  url,
  provider: { "@id": `${BASE}#business` },
  areaServed: "Iraq",
});

export const articleJsonLd = ({ title, description, image, url, author = "Madinaty Team", datePublished }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  image,
  author: { "@type": "Organization", name: author },
  publisher: { "@id": `${BASE}#business` },
  mainEntityOfPage: url,
  datePublished,
});
